import {BACKEND_URL} from '../../../../util/api'
import * as type from './type'

export const uploadCSVRequest = () => ({
    type: type.UPLOAD_CSV_REQUEST,
})

export const uploadCSVError = (error) => ({
    type: type.UPLOAD_CSV_ERROR,
    payload: {
        error,
    },
})

export const uploadCSVSuccess = (paymentList) => ({
    type: type.UPLOAD_CSV_SUCCESS,
    payload: {
        paymentList,
    },
})

export const uploadDBCSV = (file) => (dispatch) => {
    dispatch(uploadCSVRequest())

    const data = new FormData()
    data.append('file', file)

    fetch(BACKEND_URL + '/api/payment/upload-db-csv', {
        method: 'post',
        body: data,
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include',
    }).then(response => {
        return response.json()
    }).then(paymentList => {
        dispatch(uploadCSVSuccess(paymentList))
    }).catch(error => {
        dispatch(uploadCSVError(error))
    })
}

export const uploadPostFinanceCSV = (file) => (dispatch) => {
    dispatch(uploadCSVRequest())

    const data = new FormData()
    data.append('file', file)

    fetch(BACKEND_URL + '/api/payment/upload-pf-csv', {
        method: 'post',
        body: data,
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include',
    }).then(response => {
        return response.json()
    }).then(paymentList => {
        dispatch(uploadCSVSuccess(paymentList))
    }).catch(error => {
        dispatch(uploadCSVError(error))
    })
}

export const uploadZABCSV = (file) => (dispatch, getState) => {
    dispatch(uploadCSVRequest())

    const data = new FormData()
    data.append('file', file)

    fetch(BACKEND_URL + '/api/payment/upload-zab-csv', {
        method: 'post',
        body: data,
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include',
    }).then(response => {
        return response.json()
    }).then(paymentList => {
        dispatch(uploadCSVSuccess(paymentList))
    }).catch(error => {
        dispatch(uploadCSVError(error))
    })
}

export const uploadTabeoCSV = (file) => (dispatch) => {
    dispatch(uploadCSVRequest())

    const data = new FormData()
    data.append('file', file)

    fetch(BACKEND_URL + '/api/payment/upload-tabeo-csv', {
        method: 'post',
        body: data,
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include',
    }).then(response => {
        return response.json()
    }).then(paymentList => {
        dispatch(uploadCSVSuccess(paymentList))
    }).catch(error => {
        dispatch(uploadCSVError(error))
    })
}

export const uploadSplitItCSV = (file) => (dispatch) => {
    dispatch(uploadCSVRequest())

    const data = new FormData()
    data.append('file', file)

    fetch(BACKEND_URL + '/api/payment/upload-splitit-csv', {
        method: 'post',
        body: data,
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include',
    }).then(response => {
        return response.json()
    }).then(paymentList => {
        dispatch(uploadCSVSuccess(paymentList))
    }).catch(error => {
        dispatch(uploadCSVError(error))
    })
}



// WEBPACK FOOTER //
// ./src/modules/payment/state/upload/action.js